"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var FocusableHOC_1 = require("../../hocs/Focusable/FocusableHOC");
var button_next_1 = require("./button-next");
exports.ButtonNext = FocusableHOC_1.withFocusable(button_next_1.ButtonNext);
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/wix-ui-core/dist/src/components/button-next/index.js
// module id = 1348
// module chunks = 0